import {
  AppstoreOutlined,
  PlusCircleOutlined,
  ProjectOutlined,
  UnorderedListOutlined
} from '@ant-design/icons'
import { MenuProps } from 'antd/lib/menu'
import { MenuItemType } from 'app/components/UI-Elements/Type'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useRentalCreate } from 'app/lib/hooks/useRentalCreate'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import TabBarItem from './TabBarItem'

interface Props extends MenuProps {
  highlighted?: string[]
}

const Menu: React.FC<Props> = ({ highlighted }) => {
  const { tComponent } = ToolBox.useString()
  const { createRental, loading } = useRentalCreate()
  const navigate = useNavigate()

  const translate = (id: string) =>
    tComponent({
      componentType: 'navigation',
      componentName: 'tabbar',
      recordType: RecordType.overview,
      id
    })

  const menuItems: MenuItemType[] = [
    {
      title: translate('overview'),
      key: Routes.Overview.collection().index,
      icon: <AppstoreOutlined />
    },
    {
      title: translate('rentals'),
      key: Routes.Rental.collection().index,
      icon: <UnorderedListOutlined />
    },
    {
      title: translate('projects'),
      key: Routes.Project.collection().index,
      icon: <ProjectOutlined />
    },
    {
      title: translate('new_rental'),
      key: Routes.Checkout.member().show,
      icon: <PlusCircleOutlined />,
      loading: loading,
      onClick: () => createRental()
    }
  ]

  const onChange = (item: MenuItemType) => {
    item.onClick?.(undefined)
    navigate(item.key)
  }

  return (
    <>
      {menuItems.map((item) => (
        <TabBarItem
          loading={item.loading}
          selected={highlighted.includes(item.key)}
          onClick={() => onChange(item)}
          {...item}
          key={item.key}
        />
      ))}
    </>
  )
}

export default Menu
